<template>
  <div class="page-full">
    <div class="container">

      <div class="filters">
        <button @click="filterAlerts()">Filter</button>
        <button @click="exportAlerts()" :disabled="exporting">Export</button>

        <!-- Time -->
        <h3 class="subtitle">Time period:</h3>
        <div class=filter>
          <input type="date" v-model="filterAfter"> - <input type="date" v-model="filterBefore">
        </div>

        <!-- Tags -->
        <h3 class="subtitle">Tags:</h3>

        <div class=filter v-for="tag in orderedSourceTags" :key="tag[0]">
          <input type="checkbox" :value="tag[0]" v-model="filterTags" checked="true">
          <label :for="tag[0]">#{{ tag[0] }} ({{ tag[1] }})</label>
        </div>
        <br/>
        <div class=filter v-for="tag in orderedSeverityTags" :key="tag[0]">
          <input type="checkbox" :value="tag[0]" v-model="filterTags" checked="true">
          <label :for="tag[0]">#{{ tag[0] }} ({{ tag[1] }})</label>
        </div>
        <br/>
        <div class=filter v-for="tag in orderedCategoryTags" :key="tag[0]">
          <input type="checkbox" :value="tag[0]" v-model="filterTags" checked="true">
          <label :for="tag[0]">#{{ tag[0] }} ({{ tag[1] }})</label>
        </div>
        <br/>
        <div class=filter v-for="tag in orderedExtraTags" :key="tag[0]">
          <input type="checkbox" :value="tag[0]" v-model="filterTags" checked="true">
          <label :for="tag[0]">#{{ tag[0] }} ({{ tag[1] }})</label>
        </div>

        <!-- Data breaches -->
        <h3 class="subtitle">Data breaches:</h3>
        <div v-for="breach in orderedStatBreaches" :key="breach[0]">
          <input type="checkbox" :value="breach[0]" v-model="filterBreaches" checked="true">
          <label :for="breach[0]">{{ breach[0] }} ({{ breach[1] }})</label>
        </div>

      </div>
      <div class="alerts">
        <div class="top">
          <div>
            Alerts {{ alerts.length }} of {{ alertsTotal }}
          </div>
          <div>
            <input type="checkbox" value="falsepositive" v-model="falsePositive" checked="false">
            <label for="falsepositive">Include false positive</label>
            <button @click="refreshAlerts()">Refresh</button>
          </div>
        </div>
        <Alert v-for="alert in alerts" :key="alert.id" :alert="alert"/>
        <div class="load-more" @click="loadMore()" v-show="alerts.length < alertsTotal">
          Load more <font-awesome-icon icon="spinner" v-show="alertsLoading"/>
        </div>
      </div>

      <div class="stats">

        <h3 class="subtitle">Stats</h3>
        <table>
          <tr>
            <td class="stat-name">Total:</td>
            <td class="stat-value">{{ alertsStats.total ? alertsStats.total : 0 }}</td>
          </tr>
          <tr>
            <td class="stat-name">Deep Web:</td>
            <td class="stat-value">{{ alertsStats.total_deepweb ? alertsStats.total_deepweb : 0 }}</td>
          </tr>
          <tr>
            <td class="stat-name">Dark Web:</td>
            <td class="stat-value">{{ alertsStats.total_darkweb ? alertsStats.total_darkweb : 0 }}</td>
          </tr>
          <tr>
            <td class="stat-name">Data Breach:</td>
            <td class="stat-value">{{ alertsStats.total_databreach ? alertsStats.total_databreach : 0 }}</td>
          </tr>
        </table>

        <h3 class="subtitle">Severity</h3>
        <table>
          <tr>
            <td class="stat-name">Severity high:</td>
            <td class="stat-value">{{ getTagValue('severityhigh') }}</td>
          </tr>
          <tr>
            <td class="stat-name">Severity medium:</td>
            <td class="stat-value">{{ getTagValue('severitymedium') }}</td>
          </tr>
          <tr>
            <td class="stat-name">Severity low:</td>
            <td class="stat-value">{{ getTagValue('severitylow') }}</td>
          </tr>
        </table>

        <h3 class="subtitle">Category</h3>
        <table>
          <tr>
            <td class="stat-name">Sensitive disclosure:</td>
            <td class="stat-value">{{ getTagValue('sensitivedisclosure') }}</td>
          </tr>
          <tr>
            <td class="stat-name">Discussions:</td>
            <td class="stat-value">{{ getTagValue('discussions') }}</td>
          </tr>
          <tr>
            <td class="stat-name">Black markets:</td>
            <td class="stat-value">{{ getTagValue('blackmarkets') }}</td>
          </tr>
          <tr>
            <td class="stat-name">Financial information:</td>
            <td class="stat-value">{{ getTagValue('financialinformation') }}</td>
          </tr>
          <tr>
            <td class="stat-name">Exposed credentials:</td>
            <td class="stat-value">{{ getTagValue('exposedcredentials') }}</td>
          </tr>
          <tr>
            <td class="stat-name">Personal information:</td>
            <td class="stat-value">{{ getTagValue('personalinformation') }}</td>
          </tr>
          <tr>
            <td class="stat-name">Hacker group targeting:</td>
            <td class="stat-value">{{ getTagValue('hackergrouptargeting') }}</td>
          </tr>
          <tr>
            <td class="stat-name">Attacks & compromises:</td>
            <td class="stat-value">{{ getTagValue('attacksandcompromises') }}</td>
          </tr>
          <tr>
            <td class="stat-name">Unidentified:</td>
            <td class="stat-value">{{ getTagValue('unidentified') }}</td>
          </tr>
        </table>

        <pre class="debug" v-show="debugMode">{{ alertsStats }}</pre>
      </div>
    </div>

    <!-- <pre>{{alerts}}</pre> -->

  </div>
</template>

<style>
/* Define an animation behavior */
@keyframes spinner {
  to { transform: rotate(360deg); }
}
/* This is the class name given by the Font Awesome component when icon contains 'spinner' */
.fa-spinner {
  /* Apply 'spinner' keyframes looping once every second (1s)  */
  animation: spinner 1s linear infinite;
}
.top {
  display: flex;
  justify-content: space-between;
}
.stat-name {
  /*text-align: right;*/
}
.stat-value {
  font-weight: bold;
}
.subtitle {
  margin-bottom: 5px;
  font-size: 16px;
  color: #666666;
}
.page-full {
  text-align: left;
}
.container {
  display: flex;
}
.filters {
  width: 25%;
  margin-right: 10px;
}
.alerts {
  width: 50%;
  margin-right: 10px;
}
.stats {
  width: 25%;
}
.load-more {
  cursor: pointer;
  margin-top: 5px;
  padding: 5px;
  border-radius: 5px;
  border: 1px solid #cccccc;
  background-color: #eeeeee;
  text-align: center;
}
</style>

<script>
import { mapState } from 'vuex'
import tags from '@/assets/tags'
import Alert from '@/components/Alert.vue'

export default {
  name: 'alerts',
  components: {
    Alert
  },
  computed: {
    orderedSourceTags: function () {
      if (!this.alertsStats.tags) return
      var orderedTags = [
        ['deepweb', this.alertsStats.tags.deepweb ? this.alertsStats.tags.deepweb : 0],
        ['darkweb', this.alertsStats.tags.darkweb ? this.alertsStats.tags.darkweb : 0],
        ['databreach', this.alertsStats.tags.databreach ? this.alertsStats.tags.databreach : 0]
      ]
      orderedTags.sort(function(a, b) {
          return -(a[1] - b[1]) //Reverse
      })
      return orderedTags
    },
    orderedSeverityTags: function () {
      if (!this.alertsStats.tags) return
      var orderedTags = [
        ['severityhigh', this.alertsStats.tags.severityhigh ? this.alertsStats.tags.severityhigh : 0],
        ['severitymedium', this.alertsStats.tags.severitymedium ? this.alertsStats.tags.severitymedium : 0],
        ['severitylow', this.alertsStats.tags.severitylow ? this.alertsStats.tags.severitylow : 0],
        ['lowrelevance', this.alertsStats.tags.lowrelevance ? this.alertsStats.tags.lowrelevance : 0]
      ]
      orderedTags.sort(function(a, b) {
          return -(a[1] - b[1]) //Reverse
      })
      return orderedTags
    },
    orderedCategoryTags: function () {
      if (!this.alertsStats.tags) return
      var orderedTags = [
        ['sensitivedisclosure', this.alertsStats.tags.sensitivedisclosure ? this.alertsStats.tags.sensitivedisclosure : 0],
        ['discussions', this.alertsStats.tags.discussions ? this.alertsStats.tags.discussions : 0],
        ['blackmarkets', this.alertsStats.tags.blackmarkets ? this.alertsStats.tags.blackmarkets : 0],
        ['financialinformation', this.alertsStats.tags.financialinformation ? this.alertsStats.tags.financialinformation : 0],
        ['exposedcredentials', this.alertsStats.tags.exposedcredentials ? this.alertsStats.tags.exposedcredentials : 0],
        ['personalinformation', this.alertsStats.tags.personalinformation ? this.alertsStats.tags.personalinformation : 0],
        ['hackergrouptargeting', this.alertsStats.tags.hackergrouptargeting ? this.alertsStats.tags.hackergrouptargeting : 0],
        ['attacksandcompromises', this.alertsStats.tags.attacksandcompromises ? this.alertsStats.tags.attacksandcompromises : 0],
        ['unidentified', this.alertsStats.tags.unidentified ? this.alertsStats.tags.unidentified : 0]
      ]
      orderedTags.sort(function(a, b) {
          return -(a[1] - b[1]) //Reverse
      })
      return orderedTags
    },
    orderedExtraTags: function () {
      var orderedTags = []
      for (var tag in this.alertsStats.tags) {
          if (tags.reserved.includes(tag)) continue
          orderedTags.push([tag, this.alertsStats.tags[tag]]);
      }
      orderedTags.sort(function(a, b) {
          return -(a[1] - b[1]) //Reverse
      })
      return orderedTags
    },
    orderedStatBreaches: function () {
      var breaches = []
      for (var breach in this.alertsStats.databreaches) {
          breaches.push([breach, this.alertsStats.databreaches[breach]]);
      }
      breaches.sort(function(a, b) {
          return -(a[1] - b[1]) //Reverse
      })
      return breaches
    },
    ...mapState([
      'debugMode',
      'account',
      'profile',
      'alerts',
      'alertsLoading',
      'alertsTotal',
      'alertsStats',
      'exporting'
    ])
  },
  methods: {
    refreshAlerts () {
      if (!this.account.id) return
      this.$store.dispatch('loadAlertsStats', this.falsePositive)
    },
    filterAlerts () {
      this.currentPage = 1
      this.loadAlerts(this.currentPage)
    },
    exportAlerts () {
      this.$store.dispatch('exportAlerts', {
        after: this.filterAfter,
        before: this.filterBefore
      })
    },
    loadMore: function () {
      this.currentPage += 1
      this.loadAlerts(this.currentPage)
    },
    loadAlerts: function (page) {
      this.$store.dispatch('loadAlerts', {
        page: page,
        falsePositive: this.falsePositive,
        after: this.filterAfter,
        before: this.filterBefore,
        tags: this.filterTags,
        breaches: this.filterBreaches,
      })
    },
    getTagValue: function (tag) {
      // console.log('getTagValue', tag)
      if (this.alertsStats && this.alertsStats.tags && this.alertsStats.tags[tag])
        return this.alertsStats.tags[tag]
      return 0
    }
  },
  watch: {
    profile () {
      // console.log('Profile changed') TODO Find out why this is called 3 times when page is refreshed
      this.refreshAlerts()
    },
    alertsStats () {
      if (!this.alertsStats.tags) return
      // Make sure that tags filter does not contain tags that do not exist
      var tags = []
      for (var tag in this.alertsStats.tags) {
          tags.push(tag);
      }
      var validFilterTags = []
      for (var i in this.filterTags) {
        if (tags.includes(this.filterTags[i])) validFilterTags.push(this.filterTags[i])
      }
      this.filterTags = validFilterTags
      this.filterAlerts()
    }
  },
  mounted () {
    this.refreshAlerts()
  },
  data () {
    return {
      currentPage: 1,
      falsePositive: false,
      filterAfter: null,
      filterBefore: null,
      filterTags: [],
      filterBreaches: []
    }
  }
}
</script>
